export default __webpack_public_path__ + "static/media/thumb-Marine-Receiver-5.17f56344.png";